import { useNavigate } from 'react-router-dom'
import { Runtime, TemplateStatus } from '@/config/app'
import { useCreateRouteTemplate } from '@/features/templates'
import { usePreferredRuntime } from '@/app/routes/Dashboard/CreateRouteButton/CreateRouteButton.hooks'
import { useButtonNavigateClick } from '@/hooks/useButtonNavigateClick'

export const useOpenTemplate = (templateId: number) => {
  return useButtonNavigateClick(`/templates/routes/${templateId}`)
}

export const useCreatePreferredRouteTemplate = (): [(runtime: Runtime) => void, boolean] => {
  const navigate = useNavigate()
  const [preferredRuntime, setPreferredRuntime] = usePreferredRuntime()
  const createTemplate = useCreateRouteTemplate()

  const startPreferredRoute = async (runtime: Runtime) => {
    if (runtime !== preferredRuntime) {
      setPreferredRuntime(runtime)
    }

    const template = await createTemplate.mutateAsync({
      template: {
        name: `New ${runtime} template`,
        type: 'httpV1',
        runtime,
      },
      code: '',
    })

    if (template.id) {
      navigate(`/templates/routes/${template.id}`)
    }
  }

  return [startPreferredRoute, createTemplate.isPending]
}

export const getRouteTemplateStatusLabel = (status: TemplateStatus) => {
  const labels = {
    [TemplateStatus.Draft]: 'Draft',
    [TemplateStatus.Published]: 'Published',
  }

  return labels[status] ?? status ?? '-'
}
